<template>
  <div class="master">
    <div class="presentation-container">
      <!-- Slide 1: Título -->
      <div class="slide">
        <h1>🚀 Plataforma Digital de Inclusão Financeira</h1>
        <div style="text-align: center; margin: 40px 0;">
          <h2 style="border: none; color: #667eea;">Proposta Personalizada para OFEC Moçambique</h2>
          <p style="font-size: 1.2em; color: #666; margin-top: 20px;">
            Transformando o acesso aos serviços financeiros em comunidades rurais através de tecnologia USSD,
            carteira móvel e aplicações móveis
          </p>
        </div>
        <div class="highlight">
          <strong>🎯 Objetivo:</strong> Implementar uma solução tecnológica que permita à OFEC expandir seu alcance
          e eficiência na prestação de serviços de inclusão financeira, baseado no BPMN fornecido.
        </div>
      </div>

      <!-- Slide 2: Análise OFEC -->
      <div class="slide">
        <h2>📊 Perfil OFEC - Parceiro Estratégico</h2>
        <div class="feature-grid">
          <div class="feature-card">
            <h3><span class="icon">🏢</span>Organização</h3>
            <ul class="benefits-list">
              <li>ONG nacional fundada em 2017</li>
              <li>+7 anos de experiência comprovada</li>
              <li>Foco em desenvolvimento comunitário</li>
              <li>Instituição Financeira de Desenvolvimento</li>
            </ul>
          </div>
          <div class="feature-card">
            <h3><span class="icon">🌍</span>Presença Geográfica</h3>
            <ul class="benefits-list">
              <li>5 Províncias ativas</li>
              <li>Niassa, Cabo Delgado, Nampula</li>
              <li>Zambezia, Maputo</li>
              <li>Foco em comunidades rurais</li>
            </ul>
          </div>
<!--          <div class="feature-card">-->
<!--            <h3><span class="icon">🤝</span>Parcerias</h3>-->
<!--            <ul class="benefits-list">-->
<!--              <li>USAID (Agência dos EUA)</li>-->
<!--              <li>SDC (Cooperação Suíça)</li>-->
<!--              <li>GITOC (Projetos Especiais)</li>-->
<!--              <li>Empresas de Responsabilidade Social</li>-->
<!--            </ul>-->
<!--          </div>-->
          <div class="feature-card">
            <h3><span class="icon">💰</span>Serviços Atuais</h3>
            <ul class="benefits-list">
              <li>Microcrédito rural</li>
              <li>Grupos de Poupança (VSLAs/ASCAs)</li>
              <li>Literacia financeira</li>
              <li>Ligações com Instituições Financeiras, seguradoras e Fintech</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Slide 3: Solução Proposta -->
      <div class="slide">
        <h2>💡 Solução Baseada no BPMN Fornecido</h2>
        <div class="highlight">
          <strong>🔧 Implementação Técnica:</strong> Baseado no mapeamento de processos enviado pela OFEC,
          nossa solução integra perfeitamente com os fluxos existentes de cadastro, poupança, crédito e pagamentos.
        </div>

        <div class="feature-grid">
          <div class="feature-card">
            <h3><span class="icon">📱</span>Perfil Beneficiário (USSD)</h3>
            <ul class="benefits-list">
              <li>Acesso via USSD (sem internet)</li>
              <li>Cadastro simplificado</li>
              <li>Consulta de saldo e extrato</li>
              <li>Solicitação de crédito</li>
              <li>Pagamento de prestações</li>
            </ul>
          </div>
          <div class="feature-card">
            <h3><span class="icon">👨‍💼</span>Técnico de Campo</h3>
            <ul class="benefits-list">
              <li>App móvel completo</li>
              <li>Cadastro de novos beneficiários</li>
              <li>Gestão de cadernetas (VSLAs)</li>
              <li>Processamento offline</li>
              <li>Sincronização automática</li>
            </ul>
          </div>
          <div class="feature-card">
            <h3><span class="icon">🏦</span>Perfil Master</h3>
            <ul class="benefits-list">
              <li>Dashboard executivo</li>
              <li>Controle total de acessos</li>
              <li>Relatórios para doadores</li>
              <li>Gestão multi-província</li>
              <li>Analytics de impacto social</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Slide 4: Planos de Preços -->
      <div class="slide">
        <h2>💰 Opções de Investimento</h2>
        <div class="pricing-table">
          <div class="pricing-card recommended">
            <h3>🔒 EXCLUSIVIDADE OFEC</h3>
            <div class="price">150.000 MZN</div>
            <p><strong>Taxa única + 40.000 MZN/mês</strong></p>
            <ul class="benefits-list">
              <li>Direitos exclusivos do módulo</li>
              <li>Customizações ilimitadas</li>
              <li>Suporte dedicado 24/7</li>
              <li>5 províncias incluídas</li>
              <li>Transações ilimitadas</li>
              <li>API personalizada</li>
            </ul>
          </div>
          <div class="pricing-card">
            <h3>📦 PLANO NACIONAL</h3>
            <div class="price">35.000 MZN</div>
            <p><strong>Mensalidade (não exclusivo)</strong></p>
            <ul class="benefits-list">
              <li>Até 10.000 beneficiários</li>
              <li>5 províncias incluídas</li>
              <li>30.000 transações/mês</li>
              <li>Suporte telefônico</li>
              <li>Relatórios para doadores</li>
              <li>Dashboard executivo</li>
              <li>SLA 99% uptime</li>
            </ul>
          </div>
          <div class="pricing-card">
            <h3>🎯 PLANO FLEXÍVEL</h3>
            <div class="price">8 MZN</div>
            <p><strong>Por transação + 5.000 MZN base</strong></p>
            <ul class="benefits-list">
              <li>Ideal para sazonalidade</li>
              <li>Sem compromisso de volume</li>
              <li>Crescimento orgânico</li>
              <li>Teste de mercado</li>
              <li>Pagamento conforme uso</li>
              <li>Setup: 15.000 MZN</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Slide 5: ROI e Benefícios -->
      <div class="slide">
        <h2>📈 Retorno do Investimento</h2>
        <div class="stats-grid">
          <div class="stat-card">
            <span class="stat-number">60%</span>
            <span>Redução em Tempo de Processamento</span>
          </div>
          <div class="stat-card">
            <span class="stat-number">300%</span>
            <span>Aumento na Capacidade de Atendimento</span>
          </div>
          <div class="stat-card">
            <span class="stat-number">95%</span>
            <span>Redução de Erros Manuais</span>
          </div>
          <div class="stat-card">
            <span class="stat-number">24/7</span>
            <span>Disponibilidade do Serviço</span>
          </div>
        </div>

        <div class="comparison-table">
          <table style="width: 100%;">
            <thead>
            <tr>
              <th>Aspecto</th>
              <th>Situação Atual</th>
              <th>Com Plataforma Digital</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Atendimento Simultâneo</td>
              <td>Limitado a equipe presente</td>
              <td>Até 10.000 beneficiários</td>
            </tr>
            <tr>
              <td>Cobertura Geográfica</td>
              <td>Apenas presencial</td>
              <td>5 províncias simultâneas</td>
            </tr>
            <tr>
              <td>Processamento</td>
              <td>Manual e moroso</td>
              <td>Automatizado 24/7</td>
            </tr>
            <tr>
              <td>Relatórios Doadores</td>
              <td>Compilação manual</td>
              <td>Automáticos em tempo real</td>
            </tr>
            <tr>
              <td>Custo Operacional</td>
              <td>Alto (deslocamentos)</td>
              <td>Redução de 40-60%</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Slide 6: Módulos Especiais -->
      <div class="slide">
        <h2>🎁 Funcionalidades Específicas para OFEC</h2>
        <div class="feature-grid">
          <div class="feature-card">
            <h3><span class="icon">💰</span>Gestão de VSLAs/ASCAs</h3>
            <p>Sistema completo para grupos de poupança rotativa, com controle de membros, contribuições e empréstimos internos.</p>
          </div>
          <div class="feature-card">
            <h3><span class="icon">🏦</span>Microcrédito Direto</h3>
            <p>Análise automatizada de crédito com scoring personalizado para comunidades rurais, baseado no histórico de poupança.</p>
          </div>
          <div class="feature-card">
            <h3><span class="icon">📚</span>Literacia Financeira</h3>
            <p>Módulo educacional integrado com conteúdos em português e línguas locais, gamificação e certificados.</p>
          </div>
          <div class="feature-card">
            <h3><span class="icon">📱</span>USSD Zonas Rurais</h3>
            <p>Acesso via códigos USSD (*800#) para áreas sem internet, com menus intuitivos e suporte multilíngue.</p>
          </div>
          <div class="feature-card">
            <h3><span class="icon">🌍</span>Gestão Multi-Província</h3>
            <p>Dashboard centralizado para coordenação entre Nampula, Cuamba, Lichinga, Quelimane e Pemba.</p>
          </div>
          <div class="feature-card">
            <h3><span class="icon">📊</span>Relatórios de Impacto</h3>
            <p>Métricas específicas para doadores com indicadores de inclusão financeira e desenvolvimento social.</p>
          </div>
        </div>
      </div>

      <!-- Slide 7: Cronograma -->
      <div class="slide">
        <h2>⏰ Cronograma de Implementação</h2>
        <div class="timeline">
          <div class="timeline-item">
            <h3>Mês 1: Análise e Customização</h3>
            <p>• Levantamento detalhado dos processos OFEC<br>
              • Adaptação da plataforma aos workflows existentes<br>
              • Configuração de perfis e permissões<br>
              • Preparação do ambiente de desenvolvimento</p>
          </div>
          <div class="timeline-item">
            <h3>Mês 2: Desenvolvimento e Testes</h3>
            <p>• Implementação dos módulos específicos<br>
              • Integração com sistemas M-Pesa/M-Kesh<br>
              • Testes de segurança e performance<br>
              • Validação com equipe OFEC</p>
          </div>
          <div class="timeline-item">
            <h3>Mês 3: Treinamento e Piloto</h3>
            <p>• Capacitação da equipe técnica (40 horas)<br>
              • Projeto piloto em 1 província<br>
              • Ajustes baseados no feedback<br>
              • Preparação para rollout completo</p>
          </div>
          <div class="timeline-item">
            <h3>Mês 4-6: Rollout Nacional</h3>
            <p>• Expansão gradual para as 5 províncias<br>
              • Migração de dados históricos<br>
              • Monitoramento e otimização<br>
              • Suporte contínuo e ajustes</p>
          </div>
        </div>
      </div>

      <!-- Slide 8: Condições Especiais -->
      <div class="slide">
        <h2>🤝 Condições Especiais para OFEC</h2>
        <div class="feature-grid">
          <div class="feature-card">
            <h3><span class="icon">💳</span>Facilidades de Pagamento</h3>
            <ul class="benefits-list">
              <li>2 meses de carência para implementação</li>
              <li>20% desconto para pagamento anual antecipado</li>
              <li>Parcelamento da taxa de exclusividade em 6x</li>
              <li>Sem juros ou taxas administrativas</li>
            </ul>
          </div>
          <div class="feature-card">
            <h3><span class="icon">🎓</span>Suporte Adicional</h3>
            <ul class="benefits-list">
              <li>40 horas de treinamento incluídas</li>
              <li>Migração de dados sem custo</li>
              <li>Gestor de conta dedicado</li>
              <li>3 customizações anuais incluídas</li>
            </ul>
          </div>
          <div class="feature-card">
            <h3><span class="icon">🔧</span>Integrações Incluídas</h3>
            <ul class="benefits-list">
              <li>M-Pesa e M-Kesh para pagamentos</li>
              <li>APIs para sistemas existentes</li>
              <li>Integração com bancos parceiros</li>
              <li>Conexão com plataformas de doadores</li>
            </ul>
          </div>
          <div class="feature-card">
            <h3><span class="icon">📈</span>Garantias</h3>
            <ul class="benefits-list">
              <li>SLA 99,5% de disponibilidade</li>
              <li>Backup automático diário</li>
              <li>Suporte 24/7 em português</li>
              <li>Atualizações regulares incluídas</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Slide 9: Próximos Passos -->
      <div class="slide">
        <div class="cta-section">
          <h2 style="color: white; border: none;">🚀 Próximos Passos</h2>
          <p style="font-size: 1.2em; margin: 20px 0;">
            Transforme a inclusão financeira em Moçambique com a OFEC
          </p>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px; margin: 30px 0;">
            <div style="background: rgba(255,255,255,0.1); padding: 20px; border-radius: 10px;">
              <h3 style="color: white;">1. Aprovação Interna</h3>
              <p>Discussão e aprovação da proposta pela direção OFEC</p>
            </div>
            <div style="background: rgba(255,255,255,0.1); padding: 20px; border-radius: 10px;">
              <h3 style="color: white;">2. Reunião Técnica</h3>
              <p>Alinhamento final dos requisitos e cronograma</p>
            </div>
            <div style="background: rgba(255,255,255,0.1); padding: 20px; border-radius: 10px;">
              <h3 style="color: white;">3. Assinatura</h3>
              <p>Formalização da parceria e início do projeto</p>
            </div>
          </div>
          <!--                <a href="#" class="cta-button">Agendar Reunião de Alinhamento</a>-->
        </div>
      </div>

      <!-- Slide 10: Contato -->
      <div class="slide">
        <h2>📞 Informações de Contato</h2>
        <div style="text-align: center; padding: 20px;">
          <div class="highlight">
            <h3>Equipe CreditFlow</h3>
            <p><strong>Especialistas em Soluções Fintech para ONGs</strong></p>
            <br>
            <p>📧 info@creditflowmz.com</p>
            <p>📱 +258 87 778 2067</p>
            <p>🌐 www.creditflowmz.com</p>
            <br>
            <p><em>"Juntos, podemos expandir o impacto da OFEC e alcançar mais comunidades em todo Moçambique."</em></p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "OFECApresentation",
  mounted() {
    document.addEventListener('DOMContentLoaded', function() {
      const slides = document.querySelectorAll('.slide');

      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      }, observerOptions);

      slides.forEach(slide => {
        observer.observe(slide);
      });

    });
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.master {
  font-family: 'Arial', sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #333;
  overflow-x: hidden;
  padding-top: 80px;
}

.presentation-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.slide {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  margin: 30px 0;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  transform: translateY(20px);
  opacity: 0;
  animation: slideIn 0.8s ease-out forwards;
}

@keyframes slideIn {
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.slide:nth-child(odd) {
  animation-delay: 0.2s;
}

.slide:nth-child(even) {
  animation-delay: 0.4s;
}

h1 {
  color: #2c3e50;
  font-size: 2.5em;
  margin-bottom: 20px;
  text-align: center;
  background: linear-gradient(45deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

h2 {
  color: #34495e;
  font-size: 1.8em;
  margin-bottom: 25px;
  border-bottom: 3px solid #667eea;
  padding-bottom: 10px;
  position: relative;
}

h2::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(45deg, #667eea, #764ba2);
}

h3 {
  color: #2980b9;
  font-size: 1.3em;
  margin: 20px 0 15px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
  margin: 30px 0;
}

.feature-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 25px;
  border-radius: 15px;
  border-left: 5px solid #667eea;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.pricing-table {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin: 30px 0;
}

.pricing-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  position: relative;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.pricing-card:hover {
  border-color: #667eea;
  transform: scale(1.02);
}

.pricing-card.recommended {
  border-color: #667eea;
  /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
  /*color: white;*/
  transform: scale(1.05);
}

.pricing-card.recommended::before {
  content: 'RECOMENDADO';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: #ff6b6b;
  color: white;
  padding: 5px 20px;
  border-radius: 20px;
  font-size: 0.8em;
  font-weight: bold;
}

.price {
  font-size: 2.5em;
  font-weight: bold;
  margin: 20px 0;
  color: #667eea;
}

/*.pricing-card.recommended .price {*/
/*    color: white;*/
/*}*/

.benefits-list {
  list-style: none;
  margin: 20px 0;
}

.benefits-list li {
  padding: 8px 0;
  position: relative;
  padding-left: 25px;
}

.benefits-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #27ae60;
  font-weight: bold;
  font-size: 1.2em;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.comparison-table th,
.comparison-table td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.comparison-table th {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: bold;
}

.comparison-table tr:hover {
  background: #f8f9fa;
}

.cta-section {
  text-align: center;
  padding: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px;
  margin: 30px 0;
}

.cta-button {
  display: inline-block;
  background: white;
  color: #667eea;
  padding: 15px 40px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  margin-top: 20px;
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.highlight {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  padding: 20px;
  border-radius: 10px;
  border-left: 5px solid #f39c12;
  margin: 20px 0;
}

.icon {
  font-size: 1.5em;
  margin-right: 10px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin: 30px 0;
}

.stat-card {
  background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
  color: white;
  padding: 25px;
  border-radius: 15px;
  text-align: center;
}

.stat-number {
  font-size: 2.5em;
  font-weight: bold;
  display: block;
}

.timeline {
  position: relative;
  padding: 30px 0;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 3px;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.timeline-item {
  position: relative;
  margin: 30px 0;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  width: 45%;
}

.timeline-item:nth-child(odd) {
  left: 0;
}

.timeline-item:nth-child(even) {
  left: 55%;
}

.timeline-item::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #667eea;
  top: 50%;
  transform: translateY(-50%);
}

.timeline-item:nth-child(odd)::before {
  right: -31px;
}

.timeline-item:nth-child(even)::before {
  left: -31px;
}

@media (max-width: 768px) {
  .slide {
    padding: 20px;
    margin: 15px 0;
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.5em;
  }

  .feature-grid,
  .pricing-table {
    grid-template-columns: 1fr;
  }

  .timeline::before {
    left: 20px;
  }

  .timeline-item {
    width: calc(100% - 40px);
    left: 40px !important;
  }

  .timeline-item::before {
    left: -31px !important;
  }
}
</style>